import { URL_GET_ROLES_API } from 'constants/urls';

/**
 * @async
 * @function getRolesApi
 * @returns { Promise<Array> }
 */
async function getRolesApi() {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_ROLES_API, options);

	if (!res.ok) {
		const message = `HTTP error! status message: ${res.statusText}`;
		throw new Error(message);
	} else {
		const { roles } = await res.json();
		return roles;
	}
}

export default getRolesApi;
